<template>
  <div style="background-color: #fff" v-title :data-title="$route.query.seo_title">
    <!-- 头部 -->
    <div style="background: #064db4;height: 84px;width: 100%;padding-left:20px;">
      <img src="../../static/img/logo.png" alt />
    </div>

    <!-- 内容主体 -->
    <el-row style="width: 100%;margin: 0 auto;margin-bottom: 20px;padding:20px;">
      <el-col :span="24">
        <el-col :span="24" class="now_position">
          <!-- 当前位置 -->
          <nowposition-elem></nowposition-elem>
        </el-col>
        <!-- 文章列表 -->

        <el-col
          :span="24"
          style="border: 1px solid #dbdbdb;padding: 15px 20px;margin-bottom: 20px;"
        >
          <div class="title">{{details.title}}</div>

          <div class="sub_title">
            {{details.updatetime}}
            <span class="time">来源：{{details.copyfrom}}</span>
            <span class="time" v-if="details.nickname">作者：{{details.nickname}}</span>
            <span class="time">点击量：{{details.click}}</span>
          </div>
          <div v-html="details.content"></div>
        </el-col>
      </el-col>
    </el-row>
    <!-- 底部 -->
    <el-row style="margin-top: 20px;background: #064db4;padding: 10px;color:#fff;line-height: 24px;">
      <el-col :span="24">
          <p>地址：衡水市桃城区程富路6号 053000</p>
          <p>联系电话：0318-2819920 2693098</p>
          <p>版权所有 © 衡水滏阳中学 网站备案编号：冀ICP备06004153号-1</p>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import headerElem from "@/components/com/header";
import rotationElem from "@/components/com/rotation";
import footerElem from "@/components/com/footer";
import leftNavElem from "@/components/com/leftNav";
import nowpositionElem from "@/components/com/nowPosition";

var that;

export default {
  components: {
    "header-elem": headerElem,
    "rotation-elem": rotationElem,
    "footer-elem": footerElem,
    "leftNav-elem": leftNavElem,
    "nowposition-elem": nowpositionElem
  },
  data() {
    return {
      id: "",
      title: "",
      details: {}
    };
  },
  beforeCreate() {},
  created() {
    that = this;
    that.detail(that.$route.query.id);
  },
  mounted() {},
  beforeRouteEnter(to, from, next) {
    //在当前路由改变，但是该组件被复用时调用
    window.scrollTo(0, 0);
    next();
  },
  beforeRouteUpdate(to, from, next) {
    //在当前路由改变，但是该组件被复用时调用
    window.scrollTo(0, 0);
    next();
  },
  updated() {
    that.$nextTick(function() {
      var position = Number(sessionStorage.getItem("searchScrollHei"));
      $(document).scrollTop(position);
    });
  },
  methods: {
    detail(id) {
      $.ajax({
        type: "post",
        url: url + "/archivedetail?id=" + id,
        data: {},
        success: function(data) {
          if (data.code == "0") {
            console.log(data);
            that.details = data.data;
            that.title = data.data.seo_title;
          } else if (data.code == "1") {
            that.details = {};
          }
        },
        error(data) {
          alert(data.msg);
        }
      });
    }
  }
};
</script>
<style scoped>
.now_position {
  text-align: right;
}
.title {
  font-size: 25px;
  font-weight: bold;
  width: 100%;
  text-align: center;
  margin: 20px 0;
}
.sub_title {
  background: #f1f1f1;
  border: 1px solid #d5d5d5;
  text-align: center;
  line-height: 30px;
  margin: 20px 0;
}
.time {
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/articleMobile.vue